import { useQuery } from '@apollo/client'
import {
  BookkeepersManagementIncidencePayrollIntegrationStatusDocument,
  BookkeepersManagementIncidencePayrollIntegrationStatusQueryVariables,
} from 'generated/resources/graphql'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

const useGetIncidencesPayrollIntegrationStatus = ({
  variables,
}: {
  variables: BookkeepersManagementIncidencePayrollIntegrationStatusQueryVariables
}) => {
  const isBookkeeperView = useBookkeeperView()
  const { data, loading, refetch } = useQuery(
    BookkeepersManagementIncidencePayrollIntegrationStatusDocument,
    {
      variables,
      context: {
        isBookkeeperView,
      },
    }
  )

  return {
    loading,
    data: data?.bookkeepersManagement.incidencePayrollIntegrationStatusesConnection.nodes || [],
    refetch,
  }
}

export default useGetIncidencesPayrollIntegrationStatus
